module.exports = __webpack_public_path__ + "img/logo.07d1e22e.svg";